import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { ApiConfigService } from '../services/api-config.service';
import { LanguageService } from '../services/language.service';

@Injectable({
  providedIn: 'root'
})
export class ExperiencesFeatureGuard implements CanActivate {
  constructor(
    private readonly apiConfig: ApiConfigService,
    private readonly router: Router,
    private readonly language: LanguageService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.apiConfig.getFeatureFlags().pipe(
      take(1),
      map((flags) => flags.showExperiences ? true : this.router.createUrlTree(['/', this.language.currentLanguage]))
    );
  }
}
